import * as Sentry from '@sentry/react';
import { ScriptixDescendant } from '@utils/types/editors/transcripts/transcript.ts';
import { Editor, Transforms } from 'slate';

export const replaceSpeakersInEditorChildren = (
  editor: Editor,
  oldSpeaker: string,
  newSpeaker: string
) => {
  try {
    // Use Slate's Transforms API to properly update nodes
    const pathsToUpdate: number[][] = [];

    for (let i = 0; i < editor.children.length; i++) {
      const child = editor.children[i] as ScriptixDescendant;
      if (child.speaker === oldSpeaker) {
        pathsToUpdate.push([i]);
      }
    }

    // Apply transformations using Slate's API
    Editor.withoutNormalizing(editor, () => {
      pathsToUpdate.forEach(path => {
        Transforms.setNodes(
          editor,
          { speaker: newSpeaker } as Partial<ScriptixDescendant>,
          { at: path }
        );
      });
    });
  } catch (error) {
    Sentry.addBreadcrumb({
      category: 'editor',
      message: 'replaceSpeakersInEditorChildren failed',
      level: 'error',
      data: { oldSpeaker, newSpeaker, error: String(error) }
    });
  }
};
